/**
 * useMasterData フック
 */

import { useContext } from 'react';
import { MasterDataContextType, MasterDataContext } from '../contexts/MasterDataContext';

export const useMasterData = (): MasterDataContextType => {
  const context = useContext(MasterDataContext);
  if (context === undefined) {
    throw new Error('useMasterDataは MasterDataProvider 内で使用する必要があります');
  }
  return context;
};
